var __WEBPACK_NAMESPACE_OBJECT__ = externalMods.get("perfBandPreloaded");